// extracted by mini-css-extract-plugin
export default {"wrapper":"DrawingDummy_wrapper__1O+dM","iconWrapper":"DrawingDummy_iconWrapper__o5-ZR","icon":"DrawingDummy_icon__JbDgR","text":"DrawingDummy_text__yUNf7"};